import qs from 'qs';
import { toUnderscoreObject } from 'helpers/toUnderscore';
import dotToPath from 'helpers/dotToPath';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const skillsEndpoint = {
  dataURL: 'skills',
  sourceName: 'skillsList',
  autoLoad: true,
  getDataUrl: (
    url,
    { page = 1, perPage = 6, filters: { id, name, ...filtersRest }, sort, search }
  ) => {
    const urlData = {
      filters: toUnderscoreObject(dotToPath({ ...filtersRest, search: name }), false)
    };

    // Handle sort_by_occurrence parameter
    if (sort && typeof sort === 'object' && sort.occurrence) {
      urlData.sort_by_occurrence = true;
    }

    if (search) {
      urlData.search = search;
    }

    const offset = (page - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    if (id) {
      urlData.id = id;
    }

    const flatFilters = {};

    for (const [key, value] of Object.entries(urlData.filters)) {
      let vals = value;
      if (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        Object.keys(value).every((k) => String(Number(k)) === k)
      ) {
        vals = Object.values(value);
      }

      flatFilters[`${key}`] = Array.isArray(vals) ? vals.join(',') : vals;
    }

    const queryString = qs.stringify(
      cleanDeep(
        {
          ...urlData,
          filters: {
            ...flatFilters
          }
        },
        {
          NaNValues: true
        }
      )
    );

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    // Extract meta from payload (handles both array and object cases)
    const meta = payload?.meta || {};
    const { limit, count, offset } = meta;

    // Extract data array from payload (could be array directly or nested in payload.data)
    const dataArray = Array.isArray(payload) ? payload : payload?.data || [];

    return {
      data: concat ? (state.data || []).concat(dataArray) : dataArray,
      page:
        offset !== undefined && limit
          ? Math.ceil(Number(offset) / Number(limit)) + 1
          : state.page || 1,
      perPage: limit || state.perPage,
      count: count !== undefined ? count : state.count
    };
  }
};

export default skillsEndpoint;
